import type { SHARING_VARIANT } from 'reactApp/components/SharingWindow/blocks/Weblink/WeblinkList/SharingNewWeblinkList.types';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';
import type { EPublicAccessRights } from 'reactApp/modules/weblinkAccessControl/weblinkAccessControl.types';

export interface SharingContentProps {
    onClose?: () => void;
    onRendered?: () => void;
    itemStorage?: EStorageType;
    id: string;
    from: EFrom;
    gaSuffix?: string;
    isPhone?: boolean;
    fromEditor?: boolean;
    intraDomainShare?: boolean;
    autoSeo?: boolean;
    withPromoTooltip?: EPromoTooltip;
    folderName?: string;
    onboardingEnabled?: boolean;
    variant?: SHARING_VARIANT;
}

export enum ExpiryPeriod {
    Unlimited = 'Unlimited',
    Hour = 'Hour',
    Day = 'Day',
    Week = 'Week',
    Month = 'Month',
    Months3 = 'Months3',
    HalfYear = 'HalfYear',
    Year = 'Year',
    Expiry = 'Expiry',
}

export enum AutoDeletePeriod {
    None = 'None',
    Day = 'Day',
    Week = 'Week',
    Month = 'Month',
    Months3 = 'Months3',
    HalfYear = 'HalfYear',
    Year = 'Year',
    Autodeleting = 'Autodeleting',
}

export interface IExpiresOptions {
    id: ExpiryPeriod;
    text: string;
    getValue: () => number;
}

export interface IAutoDeleteOptions {
    id: AutoDeletePeriod;
    text: string;
    getValue: () => number;
}

export enum EAccessRights {
    DELETE_USER = 'delete_user',
    UNMOUNT_USER = 'unmount_user',
    READ_WRITE = 'read_write',
    READ_ONLY = 'read_only',
    COMMENT = 'comment',
}

export enum SharingTabs {
    WEBLINK = 'weblink',
    CLOUD_USERS = 'cloud_users',
    CLOUD_USERS_BIZ = 'cloud_users_biz',
    WEBLINK_ACCESS_LIST = 'weblink_access_list',
}

export interface IAccessRightsOptions {
    text: string;
    key: EAccessRights;
    dropdownText: string;
}

export interface IPublicAccessRightsOptions {
    text: string;
    key: EPublicAccessRights;
    dropdownText: string;
}

export enum AccessStatus {
    ReadOnly = 'ReadOnly',
    Edit = 'Edit',
    Upload = 'Upload',
    Download = 'Download',
    Comment = 'Comment',
}

export enum DomainAccess {
    DOMESTIC = 'domestic',
    EXTERNAL = 'external',
    EMAIL_LIST_ACCESS = 'email_list_access',
}

export enum EFrom {
    WEBLINK = 'weblink',
    SHARING = 'sharing',
    ALBUMS = 'albums',
}

export enum EPromoTooltip {
    ChangeDesign = 'ChangeDesign',
    PublicPassword = 'PublicPassword',
    DisablePublicDownload = 'DisablePublicDownload',
    SharingDownloadLimits = 'SharingDownloadLimits',
}

export interface IInfo {
    access: string;
    name?: string;
    home?: string;
    owner: {
        email: string;
    };
}

interface SendSharingContentAnalyticsPayload {
    action: string;
    label?: string;
}
export type SendSharingContentAnalytics = (args: SendSharingContentAnalyticsPayload) => void;
